<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useAbility } from "@casl/vue";
import PracticeAddEditForm from "@/components/models/practice/forms/PracticeAddEditForm.vue";
definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.practice" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PRACTICE__PRACTICE);
    },
  },
});
const route = useRoute();
const defaultValues = computed(() => route.query);

const formForWhatType = computed(() => route.query.type as "gp" | "ortho");
</script>

<template>
  <v-skeleton-loader>
    <PracticeAddEditForm
      :formForWhatType="formForWhatType"
      :defaultValues
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
